import axios from 'axios';
import authService from './authService';
import { API_URL } from '@/config/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 60000,
});

api.interceptors.request.use(
  (config) => {
    const token = authService.token.get();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.logout();
    }
    return Promise.reject(error);
  }
);

const baseEndpoint = '/ia/chat-rag/sessoes';

const iaChatRagService = {
  async criarSessao(titulo) {
    try {
      const payload = titulo ? { titulo } : {};
      const response = await api.post(baseEndpoint, payload);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar sessao de IA:', error);
      throw error;
    }
  },

  async listarSessoes() {
    try {
      const response = await api.get(baseEndpoint);
      return response.data;
    } catch (error) {
      console.error('Erro ao listar sessoes de IA:', error);
      throw error;
    }
  },

  async listarMensagens(sessionId) {
    try {
      const response = await api.get(`${baseEndpoint}/${sessionId}/mensagens`);
      return response.data;
    } catch (error) {
      console.error('Erro ao listar mensagens de IA:', error);
      throw error;
    }
  },

  async enviarMensagem(sessionId, mensagem) {
    try {
      const response = await api.post(`${baseEndpoint}/${sessionId}/mensagens`, {
        mensagem,
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao enviar mensagem para IA:', error);
      throw error;
    }
  },
};

export default iaChatRagService;
